import { initializeApp } from 'firebase/app';
import { getAuth, signOut, sendPasswordResetEmail, signInWithEmailAndPassword, signInWithPopup, GoogleAuthProvider } from 'firebase/auth';

import firebaseConfig from '../firebase-config.json';

initializeApp(firebaseConfig);

export const auth = getAuth();

// Auth providers
export const googleProvider = new GoogleAuthProvider();

// Auth methods
export const deviceSignOut = () => signOut(auth);
export const sendPasswordReset = (email, actionCodeSettings) => sendPasswordResetEmail(auth, email, actionCodeSettings);
export const signInWithEmail = (email, password) => signInWithEmailAndPassword(auth, email, password);
export const signInWithGoogle = () => signInWithPopup(auth, googleProvider);
export { default as config } from '../firebase-config.json';
